import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=d5241be8&scoped=true&"
import script from "./Procedure.vue?vue&type=script&lang=js&"
export * from "./Procedure.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Procedure.vue?vue&type=style&index=0&id=d5241be8&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d5241be8",
  null
  ,true
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow,VSpacer})
